import { render, staticRenderFns } from "./ProductBagEdit.vue?vue&type=template&id=5b40ede9&scoped=true&"
import script from "./ProductBagEdit.vue?vue&type=script&lang=js&"
export * from "./ProductBagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b40ede9",
  null
  
)

export default component.exports